<!--suppress JSUnusedLocalSymbols -->
<template lang="pug">

table.ui.small.table
    thead
        tr
            //- Auftraggeber nur anzeigen, wenn Benutzer "zmuekish" ist
            th.two.wide(v-if='$auth.isZmuekish') Auftraggeber
            th.one.wide MP
            th.two.wide(style='cursor: pointer; user-select: none;' v-on:click='$emit("toggle-sort")')
                | Produkt-ID
                i.icon(v-bind:class='sortAscending ? "sort amount up" : "sort amount down"')
            th.two.wide Name
            th.two.wide Typ
            th.two.wide Kampagne
            th.one.wide Auflagen
            th.one.wide DU an DuW
            th.one.wide Liefertermin
            th.one.wide Eingestellt
            th.one.wide
    tbody
        tr(
            is='row'
            v-for='productModel in productModels'
            v-bind:key='productModel.id'
            v-bind:campaign-models='campaignModels'
            v-bind:media-production-person-models='mediaProductionPersonModels'
            v-bind:media-production-user-models='mediaProductionUserModels'
            v-bind:product-model='productModel'
            v-bind:variant-models='getVariantModels(productModel)'
        )

</template>

<script>
    import Row from './table/Row'

    // noinspection JSUnusedGlobalSymbols
    export default {
        name: 'products-table',

        components: { Row },

        methods: {

            getVariantModels(productModel) {
                return this.$store.getters['variants/allByProductId'](productModel.id)
            }

        },

        props: {

            campaignModels: {
                type: Array,
                required: true
            },

            mediaProductionPersonModels: {
                type: Array,
                required: true
            },

            mediaProductionUserModels: {
                type: Array,
                required: true
            },

            productModels: {
                type: Array,
                required: true
            },

            sortAscending: {
                type: Boolean,
                default: false
            },

            variantModels: {
                type: Array,
                required: true
            }

        }
    }

</script>
